export interface Box {
  w: number;
  h: number;
}

export interface PositionedBox extends Box {
  x: number;
  y: number;
}

/**
 * Define the svg viewBox
 * @param selection
 * @param margin
 * @returns string the viewBox string
 */
export function viewBox(selection: PositionedBox, margin: Box): string {
  const x = Math.max(0, selection.x - margin.w / 2);
  const y = Math.max(0, selection.y - margin.h / 2);
  const w = selection.w + margin.w;
  const h = selection.h + margin.h;
  return [x, y, w, h].join(' ');
}
